var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThemesIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.19952 4.83792H18.9877C19.3012 4.83792 19.5551 4.56511 19.5551 4.22962V1.08513C19.5551 0.748851 19.3012 0.476562 18.9877 0.476562H9.19952C8.88673 0.476826 8.63281 0.748851 8.63281 1.08513V4.22962C8.63281 4.56537 8.88673 4.83792 9.19952 4.83792Z",
    stroke: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.980376 10.1808H8.08954C8.38516 10.1808 8.62411 9.92348 8.62411 9.60695V6.64074C8.62411 6.32342 8.38516 6.06641 8.08954 6.06641H0.980376C0.684754 6.06641 0.445312 6.32342 0.445312 6.64074V9.60695C0.445312 9.92348 0.684754 10.1808 0.980376 10.1808Z",
    stroke: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1895 11.4082H9.16788C8.87225 11.4082 8.63281 11.6655 8.63281 11.9828V14.9482C8.63281 15.2663 8.87225 15.5228 9.16788 15.5228H14.1898C14.4847 15.5228 14.7243 15.2663 14.7243 14.9482V11.9825C14.7241 11.6652 14.4844 11.4082 14.1895 11.4082Z",
    stroke: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThemesIcon);
export default __webpack_public_path__ + "static/media/themes_icon.d8b4a7356e52cc478a926504b8ba11eb.svg";
export { ForwardRef as ReactComponent };